import {
  AppendixStructuresResponse,
  AppendixStructure,
  PredefinedSectionDocument,
} from "../Models/appendixStructure";
import call from "./call";

export const fetchPredefinedSections = async (
  workspaceId?: number,
): Promise<AppendixStructuresResponse> => {
  const { data } = await call.get<AppendixStructuresResponse>(
    `/v1/appendix_structure/`,
    {
      params: {
        workspace_id: workspaceId,
      },
    },
  );
  return data;
};

export const putPredefinedSections = async (payload: {
  workspace_id: number;
  id?: number;
  structure: PredefinedSectionDocument[];
}): Promise<AppendixStructure> => {
  const { data } = await call.put<AppendixStructure>(
    "/v1/appendix_structure/",
    payload,
  );
  return data;
};

export const deletePredefinedSections = async (id: number): Promise<void> => {
  await call.delete(`/v1/appendix_structure/${id}/`);
};
